<template>
  <h1
    class="text-primary uppercase drop-shadow-lg font-semibold leading-[1em] text-[3.3em] md:text-6xl"
    v-bind="$attrs"
  >
    <slot />
  </h1>
</template>
